import React from 'react';
import { useTheme } from 'styled-components';

const MultiLinesIcon = ({ size = 16, color, ...props }) => {
  const theme = useTheme();
  const fill = color || (theme?.dark ? '#F5F5F5' : '#292D32');
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 3.5H2C1.72667 3.5 1.5 3.27333 1.5 3C1.5 2.72667 1.72667 2.5 2 2.5H14C14.2733 2.5 14.5 2.72667 14.5 3C14.5 3.27333 14.2733 3.5 14 3.5Z"
        fill={fill}
      />
      <path
        d="M8.31333 6.83325H2C1.72667 6.83325 1.5 6.60659 1.5 6.33325C1.5 6.05992 1.72667 5.83325 2 5.83325H8.31333C8.58667 5.83325 8.81333 6.05992 8.81333 6.33325C8.81333 6.60659 8.59333 6.83325 8.31333 6.83325Z"
        fill={fill}
      />
      <path
        d="M14 10.1667H2C1.72667 10.1667 1.5 9.94008 1.5 9.66675C1.5 9.39341 1.72667 9.16675 2 9.16675H14C14.2733 9.16675 14.5 9.39341 14.5 9.66675C14.5 9.94008 14.2733 10.1667 14 10.1667Z"
        fill={fill}
      />
      <path
        d="M8.31333 13.5H2C1.72667 13.5 1.5 13.2733 1.5 13C1.5 12.7267 1.72667 12.5 2 12.5H8.31333C8.58667 12.5 8.81333 12.7267 8.81333 13C8.81333 13.2733 8.59333 13.5 8.31333 13.5Z"
        fill={fill}
      />
    </svg>
  );
};

export default MultiLinesIcon;
